/* Copyright HiGlass Team: HiGlass Examples */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('d3')) :
  typeof define === 'function' && define.amd ? define(['d3'], factory) :
  (factory(global.d3));
}(this, (function (d3) { 'use strict';

var url = 'https://gist.githubusercontent.com/pkerpedjiev/104f6c37fbfd0d7d41c73a06010a3b7e/raw/higlass-examples.json';

function render(examples) {
  var html = '';

  examples.forEach(function (example) {
    html += '\n<li class="' + (example.columns === 2 ? 'two-columns' : '') + '">\n  <a href="' + (example.url ? example.url : '') + '">\n    <figure\n      class="examples-figure"\n      style="background-image: url(' + (example.image ? example.image : '') + ')">\n    </figure>\n  </a>\n  ' + (example.title ? '<a href="' + (example.url ? example.url : '') + '">' + example.title + '</a>' : '') + '\n  ' + (example.description ? '<p class="smaller">' + example.description + '</p>' : '') + '\n  ' + (example.location ? '<div class="smaller one-line location"><input onClick="this.select();" value="' + example.location + '" /></div>' : '') + '\n</li>';
  });

  document.querySelector('#example-list').innerHTML = html;
}

d3.json(url, function (err, examples) {
  if (err) throw err;

  render(examples);
});

})));
